import CollegePredictor from "../components/CollegePredictor";
import Head from "next/head";
export default function CollegePredictorPage() {
  return (
    <div>
      <Head>
        {/* Primary Meta Tags */}
        <title>
          NEET College Predictor 2026 by NEET Support | Predict MBBS/BDS
          Colleges
        </title>
        <meta
          name="description"
          content="NEET College Predictor 2026 by NEET Support helps you find the best MBBS/BDS colleges for your NEET rank. Get accurate, quota-wise and category-wise college options based on real cut-off data."
        />
        <meta
          name="keywords"
          content="NEET 2026, NEET counselling, MBBS admission, college predictor, NEET college predictor, college predictor NEET, NEET college predictor on basis of Rank, NEET 2026 college predictor free, college predictor NEET 2026, NEET college predictor state quota, college predictor NEET UG 2026"
        />
        <meta charSet="UTF-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta name="robots" content="index, follow" />
        <link
          rel="canonical"
          href="https://neetsupport.com/neet-college-predictor"
        />

        {/* Open Graph */}
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://neetsupport.com/neet-college-predictor"
        />
        <meta
          property="og:title"
          content="NEET College Predictor 2026 | By NEET Support"
        />
        <meta
          property="og:description"
          content="Use NEET Support's College Predictor 2026 to get personalized MBBS/BDS college guidance based on your NEET rank, category, domicile, and quota preferences."
        />
        <meta
          property="og:image"
          content="https://neetsupport.com/assets/img/home/CollegePredict/NEETPredictor.png"
        />

        {/* Twitter Meta */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:url"
          content="https://neetsupport.com/neet-college-predictor"
        />
        <meta
          name="twitter:title"
          content="NEET College Predictor 2026 by NEET Support"
        />
        <meta
          name="twitter:description"
          content="Get accurate MBBS/BDS college predictions using NEET Support’s College Predictor 2026. Based on latest cut-offs and your NEET score."
        />
        <meta
          name="twitter:image"
          content="https://neetsupport.com/assets/img/home/CollegePredict/NEETPredictor.png"
        />

        {/* Schema.org: WebPage */}
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "WebPage",
              name: "NEET College Predictor 2026 by NEET Support",
              url: "https://neetsupport.com/neet-college-predictor",
              description:
                "Use NEET Support’s College Predictor to find top MBBS/BDS colleges in 2026 based on your NEET rank, category, and quota. Instant, accurate results.",
              publisher: {
                "@type": "Organization",
                name: "NEET Support",
                url: "https://neetsupport.com",
              },
            }),
          }}
        />

        {/* Schema.org: SoftwareApplication with SearchAction */}
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "SoftwareApplication",
              name: "NEET College Predictor 2026 by NEET Support",
              operatingSystem: "All",
              applicationCategory: "EducationApplication",
              description:
                "NEET College Predictor 2026 helps you discover suitable MBBS/BDS colleges by rank. Powered by NEET Support using real cutoff data.",
              url: "https://neetsupport.com/neet-college-predictor",
              offers: {
                "@type": "Offer",
                price: "49",
                priceCurrency: "INR",
              },
              publisher: {
                "@type": "Organization",
                name: "NEET Support",
                url: "https://neetsupport.com",
              },
              potentialAction: {
                "@type": "SearchAction",
                target:
                  "https://neetsupport.com/neet-college-predictor?rank={search_term_string}",
                "query-input": "required name=search_term_string",
              },
            }),
          }}
        />
      </Head>
      <CollegePredictor />
    </div>
  );
}
